import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

const PublisherConvertedFiles: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_ASA_API}/get-files`),
};

export default PublisherConvertedFiles;
